import { useContext } from 'react';
import { AdobeTargetContext } from 'components/app/AppContext';

import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

export const useExperiments = (): LDFlagSet => {
  const experiments = useContext(AdobeTargetContext);

  return experiments;
};
